/* ZENITH auto-cycle: product cards loop through their first N images (mini runway).
   Only runs on cards marked [data-autocycle]. Off-screen cards pause (IntersectionObserver).
   prefers-reduced-motion: stays static.
   2026-10-31: hover (desktop) and press (touch) now FREEZE the card on the frame the
   shopper is looking at, instead of jumping to frame 2. Desktop resumes on mouseleave;
   touch resumes 2.5s after the finger lifts (so a scroll-swipe doesn't kill it for good),
   and a tap that opens the product never sees it move again. */
(function () {
  'use strict';
  if (window.__znAutoCycle) return; window.__znAutoCycle = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cards = [];
  var RESUME_AFTER_TOUCH = 2500;

  function setup(card) {
    if (card.__zac) return; card.__zac = true;
    var frames = Array.prototype.slice.call(card.querySelectorAll('.zac__frame'));
    if (frames.length < 2 || reduce || !('IntersectionObserver' in window)) return;
    var interval = Math.max(300, Number(card.getAttribute('data-autocycle-ms')) || 750);
    var i = 0, timer = null, visible = false, held = false, ready = false, loading = false, resumeT = null;

    function show(n) {
      frames[i].classList.remove('is-on');
      i = n % frames.length;
      frames[i].classList.add('is-on');
    }
    function loadAll(cb) {
      if (loading) return; loading = true;
      var left = frames.length;
      function done() { if (--left === 0) cb(); }
      frames.forEach(function (img) {
        if (img.getAttribute('data-src')) {
          if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
        }
        if (img.complete && img.naturalWidth) done();
        else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
      });
    }
    function start() { if (timer || !visible || held || !ready || document.hidden) return; timer = setInterval(function () { show(i + 1); }, interval); }
    function stop() { clearInterval(timer); timer = null; }
    function hold() { clearTimeout(resumeT); held = true; stop(); }
    function release(delay) {
      clearTimeout(resumeT);
      resumeT = setTimeout(function () { held = false; start(); }, delay || 0);
    }

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible = e.isIntersecting;
        if (visible && !ready) loadAll(function () { ready = true; start(); });
        else if (visible) start(); else stop();
      });
    }, { rootMargin: '150px 0px' });
    io.observe(card);

    /* Desktop: freeze while the pointer is over the card */
    card.addEventListener('mouseenter', hold);
    card.addEventListener('mouseleave', function () { release(0); });
    /* Touch: freeze the moment a finger lands on the card */
    card.addEventListener('touchstart', hold, { passive: true });
    card.addEventListener('touchend', function () { release(RESUME_AFTER_TOUCH); }, { passive: true });
    card.addEventListener('touchcancel', function () { release(RESUME_AFTER_TOUCH); }, { passive: true });
    /* Click/tap that navigates: stay frozen */
    card.addEventListener('click', hold);

    cards.push({ start: start, stop: stop });
  }

  document.addEventListener('visibilitychange', function () {
    cards.forEach(function (c) { if (document.hidden) c.stop(); else c.start(); });
  });
  /* Back/forward cache: a card frozen by the tap that left the page should run again on return */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-autocycle]').forEach(function (card) { card.dispatchEvent(new Event('mouseleave')); });
  });

  function scan(root) { (root || document).querySelectorAll('[data-autocycle]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  /* filters, sort and infinite scroll re-render the grid: catch new cards */
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('[data-autocycle]')) setup(n);
        if (n.querySelectorAll) scan(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
